module.exports = __webpack_public_path__ + "static/media/notesleft.70e5ffee.svg";